import { all } from 'redux-saga/effects';
import reportsWatcher from './ReportsSaga';

function* reportsSaga() {
  yield all([
    reportsWatcher(),
  ]);
}

export default reportsSaga;
